<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Heather Lea Bowen loves a medium steak, good Kentucky whiskey, indulging in HGTV, and cheers loudly for the NFL team, the Seattle Seahawks. A Pacific Northwest native, she has begun writing contemporary adult romance novels about people you ‘know’. Her debut novel, <em>One Heart,</em> is now available.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ef79ae08